import { useId } from 'react';

const useHoneypotToken = (): string => {
  const id: string = useId();
  return `hp${id.replace(/[^a-zA-Z0-9]/g, '').toLowerCase()}`;
};

export default useHoneypotToken;
